module.exports = __webpack_public_path__ + "img/category-skill-game-hover.fa6645cd.png";